import styled, { css } from 'styled-components';
import { fontFamily } from 'components/styles/_variables';
import { respondTo } from 'components/styles/_respondTo';

export const Wrapper = styled.div`
  position: fixed;
  z-index: 998;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  bottom: 0;
  display: ${({ open }) => (open ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 20px 0;

  ${respondTo.mobile`
    padding: 0;
    height: auto;
  `}
`;

export const Content = styled.div`
  width: ${({ desktopW = 360 }) => desktopW}px;
  padding: 20px;
  //overflow-y: auto;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  ${respondTo.mobile`
    width: 340px;
    // overflow-y: scroll;
    // max-height: 100vh;
    border-radius: 0;
    justify-content: space-between;
    padding: ${({ variant }) =>
      variant === 'config' ? '30px 20px 10px 20px' : '20px 20px 10px 20px'};
      ${({ variant }) =>
        variant === 'config' &&
        css`
          width: 100% !important;
          min-height: 100vh;
          //height: 100%;
          display: flex;
          flex-direction: column;
        `}
  `}
  border-radius: ${({ variant }) => (variant === 'config' ? 0 : '8px')};
  border-radius: 8px;
  background-color: #ffffff;
`;

export const ConfigMobileHeader = styled.div`
  display: flex;
  width: 100%;
  //padding: 20px 0;
  justify-content: flex-end;
  flex: 0;
  //position: absolute;
  z-index: 2;
  div {
    padding: 0 0 0 20px;
    //height: ;
  }
  ${respondTo.desktop`
    display: none;
  `}
`;

export const ConfigMobileImgWrapper = styled.div`
  padding: 20px 0 20px 20px;
`;

export const BigClose = styled.span`
  position: absolute;
  right: 0;
  cursor: pointer;
  //top: 20px;
  ${respondTo.mobile`
    display: none !important;
  `}
`;

export const Header = styled.h4`
  font-family: ${fontFamily.primary};
  font-size: 24px;
  display: flex;
  justify-content: ${({ headerCenter = false }) =>
    headerCenter ? 'center' : 'space-between'};
  align-items: center;
  font-weight: bold;
  text-align: ${({ primaryHeader }) => (primaryHeader ? 'left' : 'center')};
  color: #636262;
  position: relative;
  margin-bottom: ${({ showDivider }) => (showDivider ? 32 : 20)}px;

  ${({ showDivider }) =>
    showDivider &&
    css`
      &::after {
        content: '';
        width: 100%;
        height: 1px;
        position: absolute;
        left: 0;
        bottom: -12px;
        //background: rbga(2, 204, 188, .3);
        background: #fdf2eb;
      }
    `}
`;

export const Body = styled.div`
  font-family: ${fontFamily.primary};
  font-size: 14px;
  text-align: center;
  color: #636262;
  margin-bottom: ${({ mb = 40 }) => mb}px;
  flex: ${({ variant }) => (variant === 'config' ? 1 : 0)};
  p.bold {
    font-weight: 600;
  }

  ${respondTo.desktop`
    // min-height: ${({ desktopMinH = '65vh' }) => desktopMinH};
    height: ${({ forceHeight }) => forceHeight && forceHeight};
    // max-height: ${({ desktopMaxH = '75vh' }) => desktopMaxH};
    // overflow: auto;
    // display: flex;
    // justify-content: center;
    // flex-direction: column;
  `}

  ${respondTo.mobile`
      margin-bottom: 20px;
  `}
`;

export const StyledBodyText = styled.p`
  font-family: ${fontFamily.primary};
  font-size: 14px;
  text-align: center;
  color: #636262;
`;

export const StyledBodyTextBold = styled.p`
  font-family: ${fontFamily.primary};
  font-size: 14px;
  text-align: center;
  color: #636262;
  font-weight: 600;
`;

export const Footer = styled.div`
  display: flex;
  //max-width: 360px;
  justify-content: flex-end;
  ${respondTo.mobile`
      justify-content: space-between;
      button {
        max-width: unset !important;
      }
  `}
`;
